export const top10Translations = {
  es: {
    title: "Top 10",
    placeholder: "Escribe el nombre de un piloto...",
    revealTooltip: "Revelar todos los pilotos",
    loading: "Cargando...",
    back:"Volver al inicio"
  },
  en: {
    title: "Top 10",
    placeholder: "Type a driver's name...",
    revealTooltip: "Reveal all drivers",
    loading: "Loading...",
    back: "Back to Home"
  }
};
